<template>
  <div class="content tipos p-1">
    <h4 class="tipos_title">
      <b>Tipos de Causas de Morte</b>
    </h4>

    <div class="pl-3 pr-3">
      <b-row align-h="between">
        <div class="ml-3 mt-1 col-4 p-0">
          <div class="form-group">
            <label
              for="busca"
              class="tipos_label">Buscar Tipos de Causas de Morte</label>
            <input
              id="busca"
              v-model="search"
              class="col-md-12 form-control form-control-sm"
              name="busca"
              placeholder="Digite o nome de tipos de causas de morte"
              type="text">
          </div>
        </div>
        <div>
          <div class="mt-3 mr-3">
            <b-button
              variant="secondary"
              size="sm"
              @click="showModal()">
              <svg
                class="button_edit_label_icon icon--xxs"
                role="presentation">
                <use :xlink:href="'#' + add.id" />
              </svg>
              Adicionar Tipo
            </b-button>
          </div>
        </div>
      </b-row>

      <Table
        :fields="fields"
        :data="tipos"
        :is-busy="isBusy"
        :search="search"
        field-search="descricao"
        @showModal="showModal"
        @onUpdateAtivo="updateAtivo" />
    </div>

    <Pagination
      :per-page="perPage"
      :page="page"
      :last-page="lastPage"
      @onPreviousPage="previousPage"
      @onNextPage="nextPage" />


    <form
      autocomplete="off"
      class="no-padding"
      @submit.prevent="callMethod()">
      <b-modal
        id="modal-cadastro"
        no-close-on-backdrop
        no-close-on-esc
        size="lg"
        class="no-padding"
        hide-header>
        <template v-slot:modal-footer>
          <div class="w-100">
            <b-row align-h="end">
              <div v-if="read">
                <b-button
                  size="sm"
                  class=""
                  variant="outline"
                  @click="$bvModal.hide('modal-cadastro')">
                  Voltar
                </b-button>
                <div
                  class="btn p-0"
                  @click="changeRead">
                  <button
                    type="reset"
                    class="mr-3 btn btn-sm btn-rounded btn-secondary">
                    Editar informações
                  </button>
                </div>
              </div>
              <div v-if="!read">
                <b-button
                  size="sm"
                  class=""
                  variant="outline"
                  @click="$bvModal.hide('modal-cadastro')">
                  Voltar
                </b-button>
                <b-button
                  size="sm"
                  type="submit"
                  class="mr-3">
                  {{ form.editar ? 'Atualizar' : 'Adicionar' }}
                </b-button>
              </div>
            </b-row>
          </div>
        </template>

        <div class="col-10">
          <div class="row">
            <div
              role="group"
              class="col-6 form-group">
              <label
                for="input-live"
                class="label">Descrição do Tipo</label>
              <b-form-input
                v-model="form.descricao"
                size="sm"
                required
                trim />
            </div>
            <div
              role="group"
              class="col-3 form-group">
              <label
                for="input-live"
                class="label">CID</label>
              <b-form-input
                v-model="form.cid"
                size="sm"
                trim />
            </div>
            <div
              role="group"
              class="col-3 form-group">
              <label
                for="input-live"
                class="label">Ativo</label>
              <b-form-checkbox
                v-model="form.ativo"
                switch
                value="1" />
            </div>
          </div>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>

  /* components */
  import Pagination from "@/components/SofiaRei/Pagination"
  import Table from "@/components/SofiaRei/Table"

  /* services */
  import CausaMorteService from "@/services/Registros/Obito/CausaMorteService"

  /* assets */
  import excludeIcon from "@/assets/icons/ic_delete_24px.svg?sprite"
  import editIcon from "@/assets/icons/pencil.svg?sprite"
  import eyeIcon from "@/assets/icons/eye.svg?sprite"
  import add from '@/assets/icons/add.svg?sprite'

  /* outros */
  import debounce from 'lodash/debounce'
  import { mapGetters } from 'vuex'

  export default {
    name: "CausaMorte",
    components: {
      Pagination,
      Table,
    },
    data () {
      return {
        search: null,
        isBusy: false,
        perPage: 10,
        page: 1,
        lastPage: 1,
        excludeIcon,
        editIcon,
        eyeIcon,
        add,
        read: false,
        title: 'Nova funerária',
        fields: [{
          key: 'id',
          label: 'Ativo'
        },{
          key: 'descricao',
          label: 'Descrição do Tipo'
        },{
          key: 'cid',
          label: 'Cid'
        },{
          key: 'acoes',
          label: ''
        }],
        tipos: [],
        form: {
          cartorio_id: this.$store.state.auth.cartorio_id,
          descricao: null,
          cid: null,
          ativo: 1,
          editar: null
        }
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
    },
    watch: {
      search: function (newSearch, oldSearch) {
        this.isBusy = true
        this.viewWatch()
      }
    },
    beforeMount () {
      try {
        loader({ text: "Obtendo dados...", active: true })
        this.init()
      } catch (e) {
        loader({ text: "", active: false })
      }
    },
    created () {
      this.viewWatch = debounce(function () {
        this.searchCausaMorte()
      }, 200)
    },
    methods: {
      async init () {
        let data = await CausaMorteService.getCausaMorte({
          cartorio_id: this.$store.state.auth.cartorio_id,
          perPage: this.perPage,
          page: this.page,
        })
        this.tipos = data.data
        this.lastPage = data.lastPage
        this.isBusy = false
        loader({ text: "", active: false })
      },
      async showModal (causa_morte = { data: {}, read: false }) {
        const { data, read } = causa_morte

        if (read) {
          return
        }

        this.$bvModal.show('modal-cadastro')
        if (data.causa_morte_id) {
          this.form.causa_morte_id = data.causa_morte_id
          this.form.descricao = data.descricao
          this.form.cid = data.cid
          this.form.ativo = data.ativo
          this.form.editar = true
        } else {
          this.form.cartorio_id = this.$store.state.auth.cartorio_id
          this.form.descricao = null
          this.form.cid = null
          this.form.ativo = 1
          this.form.editar = false
        }
      },
      async callMethod () {
        this.$bvModal.hide('modal-cadastro')
        loader({ text: "Aguarde...", active: true })

        if (this.form.causa_morte_id) {
          this.updateCausa(this.form)
        } else {
          this.saveCausaMortes(this.form)
        }
      },
      async saveCausaMortes (causa_morte) {
        try {
          let data = await CausaMorteService.saveCausaMorte(causa_morte)
          if (data.causa_morte_id) {
            objSwal.success.title = "Salvo com sucesso!"
            objSwal.success.text = ''
            Swal.fire(objSwal.success)
          } else {
            objSwal.warning.title = "Erro ao salvar, tente novamente!"
            Swal.fire(objSwal.warning)
          }
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          this.init()

          loader({ text: "", active: false })
        }
      },

      async updateCausa (causa_morte, alert = true) {
        try {
          const { causa_morte_id } = causa_morte

          causa_morte.cartorio_id = this.$store.state.auth.cartorio_id

          delete causa_morte["causa_morte_id"]
          let data = await CausaMorteService.updateCausaMorte(causa_morte, causa_morte_id)
          if (data.causa_morte_id) {
            if (alert) {
              objSwal.success.title = "Atualizado com sucesso!"
              objSwal.success.text = ''
              Swal.fire(objSwal.success)
            }
          } else {
            objSwal.warning.title = "Erro ao atualizar, tente novamente!"
            Swal.fire(objSwal.warning)
          }
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          this.init()

          loader({ text: "", active: false })
        }
      },
      previousPage () {
        this.isBusy = !this.isBusy
        this.page -= 1
        this.init()
      },
      nextPage () {
        this.isBusy = !this.isBusy
        this.page += 1
        this.init()
      },
      async searchCausaMorte () {
        let tipos = await CausaMorteService.getCausaMorte({
          cartorio_id: this.$store.state.auth.cartorio_id,
          descricao: this.search
        })
        this.tipos = tipos.data
        this.lastPage = tipos.lastPage
        this.isBusy = false
      },
      updateAtivo (data) {
        const obj = {
          descricao: data.descricao,
          causa_morte_id: data.causa_morte_id,
          ativo: !data.ativo
        }
        this.updateCausa(obj,false)
      },
      changeRead () {
        this.read = !this.read
      }
    }
  }
</script>

<style lang="scss" >
  @import "../../scss/_utilities/_exports";

  .button_edit_label_icon {
    fill: #fff;
  }

  .button_delete_label_icon {
    fill: #fff;
  }

  .tipos{
    &_title {
      background-color: $sinoreg-blue;
      color: $color-white;
      font-size: pxToRem(24);
      font-weight: 500;
      padding: pxToRem(10) pxToRem(20);
    }

    &_label {
      font-size: pxToRem(16);
    }
  }
</style>
